import React from 'react';
import * as S from './styled';
export const Chevron = () => /*#__PURE__*/React.createElement(S.Icon, {
  width: "20px",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Pijltje naar rechts",
  viewBox: "0 0 20 25"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "8.2,17.4 10.3,19.5 17.8,12.1 10.3,4.5 8.2,6.7 13.5,12.1 "
}));